module.exports = __webpack_public_path__ + "static/media/COBRANDING_ELECCIONES_2023-08.325304b1.png";